<div class="sg-bordered-input credit-card-list-element container w-100 p-2" [class.sg-bordered-input--selected]="!!selected || !!edit">
    <div class="row align-items-center credit-card-list-element__selector" *ngIf="!card" (click)="this.add.emit()">
        <div class="col pl-4 pr-0 pt-1 credit-card-list-element__mw-88px">
            <mlp-ng-icon name="custom-credit-card" size="medium"></mlp-ng-icon>
        </div>

        <div class="col col-lg-3 px-0">
            <h6 class="sg-heading__h6 mb-0">Add a new card</h6>
        </div>

        <div class="col-12 col-lg">
            <p class="m-0 ml-2 ml-lg-0 credit-card-list-element--color-sgInputPlaceholder">Playfinder accepts all major credit and debit cards</p>
        </div>
    </div>

    <div *ngIf="card" class="row px-2 align-items-center credit-card-list-element__selector" (click)="this.select.emit(this.card.id)">
        <div *ngIf="selectable" class="col credit-card-list-element__mw-32px">
            <div class="credit-card-list-element__indicator" [class.credit-card-list-element__indicator--selected]="!!selected">
                <div class="credit-card-list-element__inner"></div>
            </div>
        </div>

        <div class="col credit-card-list-element__mw-88px">
            <img [src]="cardLogo()" [alt]="card.attributes?.brand" class="w-100" />
        </div>

        <div class="col credit-card-list-element__lg-mw-30">
            <p class="credit-card-list-element__brandname mb-0 text-uppercase">{{card.attributes?.brand}}</p>
            <p class="m-0 p-0 credit-card-list-element--color-sgInputPlaceholder">Ending in {{card.attributes?.last4}}</p>
        </div>

        <div class="col-12 col-lg pl-lg-0" [class.credit-card-list-element__indent-left]="selectable">
            <p class="credit-card-list-element__brandname mb-0 mt-3 mt-lg-0">{{card.attributes?.name}}</p>
            <p class="m-0 p-0 credit-card-list-element--color-sgInputPlaceholder">Expiry Date: {{expiry()}}</p>
        </div>
    </div>

    <div class="col text-right mt-2 mt-lg-0" *ngIf="!!edit && card">
        <a (click)="this.remove.emit(this.card.id)" class="text-uppercase credit-card-list-element__remove">Remove card</a>
    </div>
</div>
